import { Editor } from '@tiptap/core';
import { DecorationSet } from '@tiptap/pm/view';

type HighlightType = 'enhance-with-notes';

export const AskAiSelectionHighlightDecorationName = 'askAiSelectionHighlight';
export interface AskAiSelectionHighlightAttributes {
  actionType?: HighlightType;
}
export interface HighlightRange {
  from: number;
  to: number;
}

export type AskAiSelectionHighlightStorage = {
  rangeSet: WeakMap<Editor, HighlightRange[]>;
  decorationSet: WeakMap<Editor, DecorationSet>;
};
